import React from "react";
import { Form } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

interface CheckboxOption {
  value: any;
  label: string;
}

export interface CheckboxInputProps {
  value: any[];
  onChange: (values: any[]) => void;
  options: CheckboxOption[];
  label?: string;
  isDisabled?: boolean;
}

export default function CheckboxInput({
  value,
  onChange,
  options,
  label = "",
  isDisabled = false,
}: CheckboxInputProps) {
  return (
    <Form.Check
      type="checkbox"
      id={uuidv4()}
      label={label}
      disabled={isDisabled}
      checked={value[0] === options[0].value}
      onChange={() =>
        onChange([
          value[0] === options[0].value ? options[1].value : options[0].value,
        ])
      }
    />
  );
}
